__turbopack_context__.v({
  "sendQuestionnaireItem": "SendQuestionnaireItem-module__DPiRjG__sendQuestionnaireItem",
  "sendQuestionnaireItemDisabled": "SendQuestionnaireItem-module__DPiRjG__sendQuestionnaireItemDisabled",
  "sendQuestionnaireItem__text": "SendQuestionnaireItem-module__DPiRjG__sendQuestionnaireItem__text",
});
